<div class="wrapper__headerComponent container my-2 mt-2">
  <div class="row align-items-center">
    <div class="col-6 col-md-6 order-1 order-md-1">
      <div class="row mb-1">
        <div class="col-md-12">
          <img src="assets/img/fondoMDJ.png" class="img-fluid" alt="..." />
        </div>
      </div>
    </div>
    <div class="col-6 col-md-6 order-2 order-md-2 d-flex flex-column align-items-center text-center">

      <img [src]="entidadJustifacil.logo"
           class="img-fluid mb-2 logo-mini"
           alt="Logo" />

      <h5 class="text-center h3-tipografia-govco mb-3">
        {{ 'login.sin-cuenta' | translate }}
      </h5>

      <div class="form-group d-grid gap-2" style="max-width: 300px; width: 100%;">
        <button type="button" class="btn-govco outline-btn-govco"
                title="{{ 'login.crear' | translate }}"
                (click)="goCrearCuenta()"
                aria-label="Crear Cuenta">
          {{ 'login.crear' | translate }}
        </button>
        <div class="d-flex flex-column flex-md-row gap-3">
          <button type="button" class="btn-govco outline-btn-govco flex-grow-1"
                  title="{{ 'login.iniciar-sesion-ciudadano' | translate }}"
                  (click)="goLogin()"
                  aria-label="Iniciar sesión como ciudadano">
            {{ 'login.iniciar-sesion-ciudadano' | translate }}
          </button>

          <button type="button" class="btn-govco outline-btn-govco flex-grow-1"
                  title="{{ 'login.iniciar-sesion-empresa' | translate }}"
                  (click)="goLoginEmpresa()"
                  aria-label="Iniciar sesión como empresa">
            {{ 'login.iniciar-sesion-empresa' | translate }}
          </button>
        </div>
        <div class="text-center mt-3">
          <button
            type="button"
            class="link-govco-btn d-block mb-1 mx-auto"
            (click)="goRememberPassword()"
            style="font-weight: 500;"
            [attr.aria-label]="'login.olvido-contrasenia' | translate">
            {{ 'login.olvido-contrasenia' | translate }}
          </button>

          <a class="link-govco link-size" routerLink="/loginAdmin">
            {{ 'login.acceso-funcionarios' | translate }}
          </a>
        </div>
      </div>

    </div>
  </div>
</div>
<div *ngIf="openModalTipoUsuario">
  <app-modal-tipo-usuario
    [tiposUsuario]="tiposUsuario"
    (tipoUsuarioEmitter)="obtenerTipoUsuario($event)"></app-modal-tipo-usuario>
</div>
